module.exports = __webpack_public_path__ + "img/cb7.a8abf924.jpg";